// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";

// LIBRERIE ESTERNE
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronDown } from "@fortawesome/free-solid-svg-icons";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

// STILI X SLINK
import heroCarouselSyle from "../../../assets/jsStyle/heroCarouselStyle";

const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false /* Default a true se non specificato*/ }) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    const carouselImages = [
        { src: "/assets/images/inHome/heroCarousel/salone.webp", alt: t('homePage.carouselImage1Alt') },
        { src: "/assets/images/inHome/heroCarousel/terrazza.webp", alt: t('homePage.carouselImage2Alt') },
        { src: "/assets/images/inHome/heroCarousel/camera.webp", alt: t('homePage.carouselImage3Alt') },
    ]

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner">

            { /* Attiva Carosello + Form di ricerca (Se attivo in Banner) */}
            {false && (
                <>
                    <Slider {...heroCarouselSyle}>
                        {carouselImages.map((image, index) => (
                            <div key={index}>
                                <img src={image.src} alt={image.alt} className="carousel-image" />
                            </div>
                        ))}
                    </Slider>

                    {showSearchForm && <PropertySearchField searchData={{}} />}
                </>
            )}

            { /* Attiva Video */}
            {false && (
                <video autoPlay muted loop playsInline preload="auto" poster="/assets/images/inHome/copertina.jpg">
                    <source src={`${LARGE_FILES_URL}/hero-video.mp4`} type="video/mp4" />
                </video>
            )}

            <div className="container-fluid w-special h-100">

                <div className="text-wrapper">
                    <div className="box-for-border"></div>
                    <div className="box-for-border"></div>
                    <h1 dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string}}></h1>
                </div>



                <div className="scroll-indicator">
                    <a href="#search-box" title="Scroll">
                        <FontAwesomeIcon icon={faCircleChevronDown} />
                    </a>
                </div>
            </div>

        </section>
    );
};

export default SubHeaderHome;